angular.module('components.caNewAddressForm', [])
    .component('caNewAddressForm', {
        templateUrl: 'main/contacts/components/newaddressform.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            addressTypes: '<',
            onAddressCreated: '&'
        },
        controller: controller
    });

// @ngInject
function controller() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.createAddress = createAddress;

    vm.selectedAddressType = {};

    function onInit() {
        if (vm.addressTypes.length !== 0) {
            vm.selectedAddressType = vm.addressTypes[0];
        }
    }
    function onChanges(changes) {
    }
    function onDestroy() {
    }

    function createAddress() {
        var newAddress = {
            addressType: vm.selectedAddressType,
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            postalcode: '',
            city: '',
            country: ''
        };

        vm.onAddressCreated({address: newAddress});
    }
}
